export const CALENDLY_DEMO_URL =
  "https://calendly.com/simon-hans-dentdesk/dentlab-demo?hide_gdpr_banner=1&primary_color=8db599";
